import React from 'react';
import { CapabilityDTO } from '@atlassiansox/phobos-client-ts';

import { DetailButtonDialog, ItemHeader } from '@/components/primitive';

import { DownstreamDependencies, UpstreamDependencies } from './dependency-list';
import * as styles from './styles';

type DependenciesProps = Required<
  Pick<CapabilityDTO, 'downstreamDependencies' | 'upstreamDependencies'>
>;

const Dependencies: React.FC<DependenciesProps> = ({
  downstreamDependencies,
  upstreamDependencies,
}) => (
  <DetailButtonDialog
    title={<ItemHeader>Dependencies</ItemHeader>}
    testId="capability-dependency-list"
    css={styles.root}
  >
    <div css={styles.main}>
      <DownstreamDependencies downstreamDependencies={downstreamDependencies} />
      <UpstreamDependencies upstreamDependencies={upstreamDependencies} />
    </div>
  </DetailButtonDialog>
);

export default Dependencies;
